'use client';

import { type TimeScalar } from '@bts-web/utils-formatting';
import { convertToLocaleDateString } from '@bts-web/utils-formatting-client';
import { useClientLocale } from '@bts-web/utils-lokalise';
import { FC } from 'react';

export const FormattedTimeScalar: FC<{
  value: TimeScalar | null | undefined;
}> = ({ value }) => {
  const locale = useClientLocale();

  return <>{convertToLocaleDateString(value, locale)}</>;
};
